<template>
    <div class="sk-notifications">
        <notification
            v-for="(notification, index) in notifications"
            :key="notification.uuid"
            :message="notification.message"
            :class="{'d-none': index > 0}"
            @delete="onDelete(notification)"
            @deleteAndRedirect="deleteAndRedirect(notification)"
        >
        </notification>
    </div>
</template>

<script>
import {deleteUserNotification} from '../utility/api/user/deleteUserNotification';
import {getUserNotifications} from '../utility/api/user/getUserNotifications';
import {listenToPusherNotifications} from '../utility/notifications/listenToPusherNotifications';
import Notification from './Notification';

export default {
    name: 'notifications',
    components: {Notification},
    data() {
        return {
            notifications: [],
        };
    },
    methods: {
        async loadStoredNotifications() {
            (await getUserNotifications()).forEach(notification => this.addNotification(notification));
        },
        initializePusherNotifications() {
            listenToPusherNotifications(notification => {
                this.addNotification(notification);
                this.broadcastNotification(notification);
            });
        },
        addNotification(notification) {
            if (!this.notifications.find(n => n.uuid === notification.uuid)) {
                this.notifications.push(notification);
            }
        },
        removeNotification(notification) {
            this.notifications = this.notifications.filter(n => n.uuid !== notification.uuid);
        },
        async onDelete(notification, redirect = false) {
            this.removeNotification(notification);
            if (!notification.is_push_notification) {
                await deleteUserNotification(notification.uuid);
            }
            if (redirect) {
                if (notification.message.cta.target) {
                    window.open(notification.message.cta.url, notification.message.cta.target)
                } else {
                    window.location.href = notification.message.cta.url
                }
            }
        },
        deleteAndRedirect(notification) {
            this.onDelete(notification, true)
        },
        broadcastNotification(notification) {
            const message = {type: 'pusherNotification', notification};
            window.postMessage(message, window.location.origin);
        }
    },
    mounted() {
        this.loadStoredNotifications();

        this.initializePusherNotifications();

        this.$root.$on('delete-notification', (notification) => {
            this.onDelete(notification)
        });

        this.$root.$on('add-notification', (notification) => {
            this.addNotification(notification)
        });
    },
};
</script>

<style lang="scss" scoped>
.sk-notifications {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
